// // import { PricingCards2 } from '@/components'
// import PricingCards2 from '../../components/common/PricingCards2'
// import { plans } from './data'

// const PricingPlans = () => {
//   return (
//     <section className="py-20">
//       <div className="container">
//         <div className="text-center max-w-2xl mx-auto">
//           <span className="text-sm font-medium py-1 px-3 rounded-full text-primary bg-primary/10">
//             Plans
//           </span>
//           <h2 className="md:text-3xl/tight text-3xl font-semibold my-4">
//             Pricing Plans
//           </h2>
//           <p className="md:text-lg text-slate-500 leading-7">
//             Pricing that <span className="text-primary">works</span> for
//             everyone.
//           </p>
//         </div>
//         <PricingCards2 plans={plans} />
//       </div>
//     </section>
//   )
// }

// export default PricingPlans



import React, { useState, useEffect } from 'react';
import { Check, Star, MessageCircle, BarChart3, Users, Zap, ArrowRight, Quote } from 'lucide-react';
import Footer1 from '../../components/common/Footer1';

const PricingPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [animatedElements, setAnimatedElements] = useState(new Set());

  const plan = {
    id: 1,
    name: 'FREE',
    price: '0',
    duration: '/ month',
    features: [
      "Access to all integrations",
      "Direct messages",
      "Unlimited contacts",
      "Unlimited messages",
      "Quick reply setup",
      "Posts managing",
      "Facebook and Instagram Stories",
      "Chatbots",
      "ChatGPT",
      "Re-engage messages",
      "Live chat",
      "Priority Support (24/7)"
    ],
    isRecommended: false,
  };

  const keyFeatures = [
    {
      icon: <MessageCircle className="w-8 h-8" />,
      title: "Multi-Platform Integration",
      description: "Connect Instagram, Facebook, and WhatsApp seamlessly"
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Automated Chat",
      description: "AI-powered chatbots with ChatGPT integration"
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: "Analytics Dashboard",
      description: "Track performance with comprehensive analytics"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Profile Management",
      description: "Manage unlimited contacts and conversations"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimatedElements(prev => new Set([...prev, entry.target.id]));
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 mt-[86px]">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#50B5FF]/8 to-purple-100/40"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
          <div 
            className={`text-center transform transition-all duration-1000 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
          >
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-blue-100 to-purple-100 text-blue-800 text-sm font-medium mb-6">
              <Star className="w-4 h-4 mr-2" />
              Start Your Journey Today
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              Simple Pricing,
              <span className="block block bg-gradient-to-r from-[#50B5FF] to-purple-600 bg-clip-text text-transparent bg-clip-text text-transparent">
                Unlimited Possibilities
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Get started with our comprehensive business communication platform absolutely free. 
              No hidden costs, no credit card required.
            </p>
          </div>
        </div>
      </div>

      {/* Main Pricing Card */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative ">
        <div 
          id="pricing-card"
          data-animate
          className={`transform transition-all duration-1000 delay-300 ${
            animatedElements.has('pricing-card') ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-16 opacity-0 scale-95'
          }`}
        >
          <div className="max-w-lg mx-auto">
            <div className="relative bg-white rounded-3xl shadow-2xl shadow-blue-500/10 border border-gray-100 overflow-hidden group hover:shadow-3xl hover:shadow-blue-500/20 transition-all duration-500">
              {/* Animated Background */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-purple-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              <div className="relative p-8 pt-12">
                {/* Plan Header */}
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name} PLAN</h3>
                  <div className="flex items-baseline justify-center">
                    <span className="text-6xl font-bold text-gray-900">$</span>
                    <span className="text-7xl font-bold text-gray-900">{plan.price}</span>
                    <span className="text-xl text-gray-500 ml-2">{plan.duration}</span>
                  </div>
                  <p className="text-gray-600 mt-4">Everything you need to get started</p>
                </div>

                {/* Features List */}
                <div className="space-y-4 mb-8">
                  {plan.features.map((feature, index) => (
                    <div 
                      key={index} 
                      className={`flex items-center space-x-3 transform transition-all duration-500 ${
                        animatedElements.has('pricing-card') ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'
                      }`}
                      style={{ transitionDelay: `${400 + index * 50}ms` }}
                    >
                      <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-r from-blue-500 to-[#50B5FF] rounded-full flex items-center justify-center">
                        <Check className="w-4 h-4 text-white" />
                      </div>
                      <span className="text-gray-700 font-medium">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                absolute inset-0 bg-gradient-to-r from-blue-500 to-[#50B5FF] opacity-0 group-hover:opacity-100 transition-opacity duration-300
                <button className="w-full bg-gradient-to-r from-[#50B5FF] to-blue-600 hover:from-[#3DA5EF] hover:to-blue-700 hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98] text-white font-bold py-4 px-8 rounded-2xl transform transition-all duration-300 hover:scale-105 hover:shadow-xl flex items-center justify-center space-x-2 group">
                  <span>Get Started Now</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Key Features Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div 
          id="features-header"
          data-animate
          className={`text-center mb-16 transform transition-all duration-1000 ${
            animatedElements.has('features-header') ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Powerful Features Included
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to manage your business communications across multiple platforms
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {keyFeatures.map((feature, index) => (
            <div 
              key={index}
              id={`feature-${index}`}
              data-animate
              className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 group border border-gray-100 transform ${
                animatedElements.has(`feature-${index}`) ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="text-blue-500 mb-4 group-hover:scale-110 transition-transform duration-300">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonial Section */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div 
            id="testimonial"
            data-animate
            className={`text-center transform transition-all duration-1000 ${
              animatedElements.has('testimonial') ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
          >
            <Quote className="w-16 h-16 text-blue-500 mx-auto mb-8" />
            <blockquote className="text-2xl md:text-3xl font-medium text-gray-900 mb-8 leading-relaxed">
              "This platform transformed how we manage customer communications. The free plan gave us everything we needed to grow our business from day one."
            </blockquote>
            <div className="flex items-center justify-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-[#50B5FF] to-purple-600 rounded-full flex items-center justify-center text-white font-bold">
                S
              </div>
              <div className="text-left">
                <div className="font-bold text-gray-900">Sarah Johnson</div>
                <div className="text-gray-600">CEO, Digital Marketing Agency</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Final CTA Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div 
          id="final-cta"
          data-animate
          className={`bg-gradient-to-r from-[#50B5FF] to-purple-600 rounded-3xl p-12 text-center text-white transform transition-all duration-1000 ${
            animatedElements.has('final-cta') ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-16 opacity-0 scale-95'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Ready to Get Started?
          </h2>
          <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
            Join thousands of businesses already using our platform to streamline their communications
          </p>
          <button className="bg-white text-blue-600 font-bold py-4 px-12 rounded-2xl hover:bg-gray-50 transform transition-all duration-300 hover:scale-105 hover:shadow-xl text-lg">
            Start Free Today
          </button>
        </div>
      </div>
      <Footer1/>
    </div>
  );
};

export default PricingPage;